import { OptionStr } from 'types/common/FormTypes';
import { Location, SubDistrict } from 'types/location/locationTypes';

export async function mapLocationsToOptions(
  options: Location[] | SubDistrict[]
): Promise<OptionStr[]> {
  return options.map((p) => ({
    value: `${p.id}`,
    label: `${p.name}`,
  }));
}

export async function mapProvincesToOptions(
  provinces: Location[] | SubDistrict[]
): Promise<OptionStr[]> {
  const options = provinces.map((p) => ({
    value: `${p.id}`,
    label: `${p.name}`,
  }));
  options.unshift({ label: '\u00A0', value: '' });
  return options;
}

interface SubDistrictOption {
  label: string;
  value: string;
  zip: string;
}
export async function mapSubDistrictToOptions(
  provinces: SubDistrict[]
): Promise<SubDistrictOption[]> {
  return provinces.map((p) => ({
    value: `${p.id}`,
    label: `${p.name}`,
    zip: `${p.postal_code}`,
  }));
}
